import React from 'react'
import * as propTypes from 'prop-types'
import withHOCs from 'util/withHocs'
import DialogBox from '../../components/DialogBox/DialogBox'
import TabbedPopUp from '../../components/PopUp/TabbedPopUp'
import CircularPageLoader from '../../components/Loader/CircularPageLoader'
import { showNotification } from '../../store/notification/actionCreator'
import { makeTabTables, getTitle } from '../../util/Table'
import { dataTabLabelsShippedVendor } from '../../enums/tableTabs'

import {
  closeAlert,
  closePopup,
  downloadSamples,
  getVendorOrders,
  getVendorOrdersNew,
  locationChange,
  setCheckBox,
  setCheckBoxForCanvasTable,
  setCheckBoxHeaderChange,
  showAlert,
  showPopup,
  setPage,
  setRowsPerPage,
  setSortedData,
} from '../../store/orderSummary/actionCreator'
import { setShipmentData } from '../../store/shipmentBarcode/actionCreator'
import { setHeaderTitleArray } from '../../store/layout/actionCreator'
import copy from 'copy-to-clipboard'
import {
  paramsFromFilters,
  ORDERSUMMARY_SELECTABLE_FILTERS,
  VENDOR_PAGE_SORT_FILTERS,
} from '../AddFilters/constants'
import { getNotFoundBlock } from '../AddFilters/FilterUtils'
import { SampleStatus } from '../../enums/sampleStatus'
import { selectPageFilters } from '../../store/filters/selectors'
import { setFilters } from '../../store/filters/actionCreator'
import { isEmpty, uniq, findIndex } from 'lodash'
import QuickFiltersCanvas from './QuickFiltersCanvas'
import { toVendorPageSortRequest } from '../../mappers/OrderMapper'
import { EnhancedTableSortComparator } from '../../components/EnhancedTable/SortComparator'
import CustomCanvasTable from 'components/CanvasTable/CustomCanvasTable'
import { Tooltip, Button, Grid, Heading } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, {
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsVerticalIcon,
} from '@enterprise-ui/icons'
import AddFiltersCanvas from 'pages/AddFilters/AddFiltersCanvas'

class OrderSummaryPageCanvas extends React.Component {
  constructor(props) {
    super(props)
    const { filters = {} } = this.props
    this.state = {
      checkAll: true,
      filters: filters,
      selectableFilters: ORDERSUMMARY_SELECTABLE_FILTERS,
      isFilterUpdated: false,
      isQuickFilterUpdated: false,
      orderBy: '',
      order: 'asc',
    }
    this.defaultParams = {
      status: SampleStatus.ORDERED,
    }
  }

  componentDidMount = () => {
    const {
      locationChange,
      selectedData,
      setHeaderTitleArray,
      setFilters = () => {},
      pageName = '',
    } = this.props
    setHeaderTitleArray([{ title: 'Requested Samples', link: `/${pageName}` }])
    locationChange(selectedData)
    setFilters({}, pageName)
  }

  componentWillUnmount() {
    const { setFilters, pageName = '' } = this.props
    const { filters = {} } = this.state
    const filterCopy = Object.assign({}, filters)
    if (!isEmpty(filterCopy)) {
      setFilters(filterCopy, pageName)
    }
  }

  componentDidUpdate(prevProps = {}, prevState = {}) {
    const {
      page: propsPage,
      rowsPerPage: propsRowsPerPage,
      data: propsData = [],
      setPage = () => {},
    } = this.props
    const {
      filters: stateFilters = {},
      isFilterUpdated: stateIsFilterUpdated,
    } = this.state
    const filtersCopy = Object.assign({}, stateFilters)
    const { page: prevPropsPage, rowsPerPage: prevPropsRowsPerPage } = prevProps
    const { isFilterUpdated: prevStateIsFilterUpdated } = prevState
    const doesRowsPerPageUpdated =
      propsPage !== prevPropsPage || propsRowsPerPage !== prevPropsRowsPerPage
    const doesFiltersUpdated =
      !!stateIsFilterUpdated &&
      stateIsFilterUpdated !== prevStateIsFilterUpdated

    if (doesRowsPerPageUpdated || doesFiltersUpdated) {
      this.refreshTableWithNewData(filtersCopy, doesFiltersUpdated)
    }

    if (doesFiltersUpdated) {
      this.setState({
        isFilterUpdated: false,
      })
    }

    if (!propsData.length && propsPage !== 1) {
      setPage(1)
    }
  }

  setFiltersUpdated = (isFilterUpdated = false, filters = {}) => {
    const filtersCopy = Object.assign({}, filters)
    this.setState({
      isFilterUpdated: isFilterUpdated,
      filters: filtersCopy,
    })
  }

  setQuickFiltersUpdated = (isQuickFilterUpdated = false, filters = {}) => {
    const filtersCopy = Object.assign({}, filters)
    const formattedFilters = Object.assign({}, { include_filters: filtersCopy })
    this.setState({
      isQuickFilterUpdated: isQuickFilterUpdated,
      filters: formattedFilters,
    })
  }

  onSortSelectedChange = (order, property, orderType = '') => {
    if (VENDOR_PAGE_SORT_FILTERS.includes(property)) {
      let { orderBy: sortBy, order: sortOrder } = this.state
      let orderBy = toVendorPageSortRequest(property)
      let order = 'desc'
      if (sortBy === orderBy && sortOrder === 'desc') {
        order = 'asc'
      }
      this.setState(
        {
          orderBy: orderBy,
          order: order,
        },
        () => {
          const {
            filters: stateFilters = {},
            isFilterUpdated: stateIsFilterUpdated,
          } = this.state
          this.refreshTableWithNewData(stateFilters, stateIsFilterUpdated)
        }
      )
    } else {
      const { data = [], setSortedData = () => {} } = this.props
      const dataComparator = EnhancedTableSortComparator(order, property)
      let dataCopy = [...data]
      let sortedData = dataCopy.sort(dataComparator)
      setSortedData(sortedData)
    }
  }

  refreshTableWithNewData = (filters = {}, doesFiltersUpdated = false) => {
    const { page, rowsPerPage, getVendorOrdersNew = () => {} } = this.props
    const { orderBy: sortBy, order: sortOrder } = this.state
    const filtersCopy = Object.assign({}, filters)
    this.setState({
      filters: filtersCopy,
    })
    const filtersFromParams = paramsFromFilters(
      filtersCopy,
      page,
      rowsPerPage,
      this.userProfilename,
      this.defaultParams,
      sortBy,
      sortOrder
    )
    const {
      requestPayload: { include_filters = {} } = {},
      requestParams = {},
    } = filtersFromParams
    Object.keys(include_filters).forEach((key) => {
      requestParams.append(key, include_filters[key])
    })
    getVendorOrdersNew(requestParams, doesFiltersUpdated)
  }

  createSortHandler =
    (property, sortType = '') =>
    (event) => {
      this.onSortSelectedChange(event, property, sortType)
    }

  onSelected = (selectedData = [], selected = {}) => {
    const { pegasusId: selectedPegId = '' } = selected
    const selectedPegIdIndex = findIndex(selectedData, function (obj = {}) {
      return obj.pegasusId === selectedPegId
    })
    return selectedPegIdIndex !== -1
  }

  handleSubmitOrder = async (event) => {
    const { selectedData = [], showAlert, setShipmentData } = this.props
    const message =
      'Please make sure that all the items are being sent to the same location'
    const sampleShipToList = selectedData.map((obj) => obj.shipTo) || []
    if (uniq(sampleShipToList).length > 1) {
      event.preventDefault()
      showAlert(message)
    } else {
      setShipmentData(selectedData)
    }
    await Promise.resolve()
    this.props.navigate('/vendorShipSamples')
  }

  disableButton = () => {
    const { selectedData = [] } = this.props
    return selectedData.length === 0
  }

  recentCommentsClick = (e) => {
    this.onSortSelectedChange('desc', 'latestComment')
  }

  additionalFiltersContent = () => {
    const { filters: stateFilters = {}, orderBy = '', order = '' } = this.state
    const { pageName = '' } = this.props
    const filtersCopy = Object.assign({}, stateFilters)
    const urlParams = new URLSearchParams(window.location.search)
    const vendorCommentsFlag = urlParams.get('vendorcomments')
    return (
      <Grid.Container container alignItems="baseline">
        <Grid.Item direction="row">
          <QuickFiltersCanvas
            filters={filtersCopy}
            refreshTableWithNewData={this.refreshTableWithNewData}
            setQuickFiltersUpdated={this.setQuickFiltersUpdated}
            pageName={pageName}
            quickFilterName={'Vendor Sample Status'}
          />
        </Grid.Item>
        {vendorCommentsFlag === 'true' ? (
          <Grid.Item>
            <Tooltip location="bottom" content={'Recently Commented'}>
              <Button
                variant={orderBy === 'comments' ? 'secondary' : ''}
                onClick={this.recentCommentsClick}
              >
                <EnterpriseIcon
                  className="start-icon-in-button"
                  icon={
                    orderBy === 'comments' && order === 'asc'
                      ? ArrowUpIcon
                      : order === 'desc'
                        ? ArrowDownIcon
                        : ArrowsVerticalIcon
                  }
                />

                {'Recently Commented'}
              </Button>
            </Tooltip>
          </Grid.Item>
        ) : (
          ''
        )}
      </Grid.Container>
    )
  }

  render() {
    const {
      alertIsVisible,
      alertMessage,
      checkBoxEnabled,
      classes = {},
      closeAlert,
      closePopup,
      columnData,
      clickableColumn,
      data,
      downloadSamples,
      numSelected,
      onCheckBoxChange,
      onCanvasTableCheckBoxChange,
      onCheckBoxHeaderChange,
      onClick,
      popupIsVisible,
      selectedData,
      showPopup,
      page,
      rowsPerPage,
      totalRowsCount,
      setPage,
      setRowsPerPage,
      handleChipClick = () => {},
      filterNFList = {},
      pageName = '',
      popupItem = {},
      auth = {},
      vendorOrderRequestPending = false,
    } = this.props
    const {
      selectableFilters = [],
      filters: stateFilters = {},
      isQuickFilterUpdated = false,
    } = this.state
    return (
      <div className="order-summary-page">
        <Grid.Container spacing={1}>
          <Grid.Item xs={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Heading className="order-summary-heading">
                Requested Samples
              </Heading>
              <Button
                type="primary"
                disabled={this.disableButton()}
                onClick={this.handleSubmitOrder}
                className="process-ship-btn"
              >
                Process Shipment
              </Button>
            </div>
          </Grid.Item>
          <Grid.Item xs={12}>
            <AddFiltersCanvas
              selectableFilters={selectableFilters}
              setFiltersUpdated={this.setFiltersUpdated}
              pageName={pageName}
              isQuickFilterUpdated={isQuickFilterUpdated}
              quickFilters={stateFilters}
              filterCompType={'include_filters'}
              mergedFilters={stateFilters}
            />
          </Grid.Item>
          <Grid.Item xs={12}>
            {getNotFoundBlock(filterNFList, stateFilters, handleChipClick)}
          </Grid.Item>
          <Grid.Item xs={12}>
            {vendorOrderRequestPending ? (
              <CircularPageLoader open={vendorOrderRequestPending} />
            ) : (
              <CustomCanvasTable
                enableDownload={true}
                columnData={columnData}
                onSortSelectedChange={this.onSortSelectedChange}
                downloadFunction={() => downloadSamples()}
                data={data}
                selectionEnabled={checkBoxEnabled}
                selected={selectedData}
                customRowCount={'Samples'}
                scrollableWidth={true}
                paginationAtApiLevel={true}
                currentPage={page}
                rowsPerPage={rowsPerPage}
                totalRowsCount={totalRowsCount}
                clickableColumn={clickableColumn}
                showPopup={(data) => showPopup(data)}
                onCheckBoxChange={(ids) => {
                  onCanvasTableCheckBoxChange(ids)
                }}
                additionalFiltersContent={this.additionalFiltersContent}
                onRequestPage={setPage}
                onPageSizeChange={setRowsPerPage}
                sortable={true}
                enableMultiSearch={true}
                uniqueIdentifierInData={'pegasusId'}
                showAllRows={true}
                isAllRowsRequired={true}
                paginationlocation="top-bottom"
                enableSearch
                additionalActions={true}
              />
            )}
          </Grid.Item>
        </Grid.Container>
        <TabbedPopUp
          dataTabLabels={dataTabLabelsShippedVendor}
          isVisible={popupIsVisible}
          data={makeTabTables(
            popupItem,
            classes,
            dataTabLabelsShippedVendor,
            {},
            [],
            '',
            '',
            '',
            auth
          )}
          onClose={closePopup}
          title={getTitle(popupItem)}
        />
        <DialogBox
          isAlertVisible={alertIsVisible}
          message={alertMessage}
          onClose={closeAlert}
          response={false}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    alertIsVisible: state.orderSummary.alertIsVisible,
    alertMessage: state.orderSummary.alertMessage,
    checkBoxEnabled: state.orderSummary.checkBoxEnabled,
    columnData: state.orderSummary.columnData,
    clickableColumn: state.orderSummary.clickableColumn,
    data: state.orderSummary.data,
    numSelected: state.orderSummary.numSelected,
    onCheckBoxChange: state.orderSummary.onCheckBoxChange,
    onCheckBoxHeaderChange: state.orderSummary.onCheckBoxHeaderChange,
    onClick: state.orderSummary.onClick,
    orderNumber: state.orderSummary.orderNumber,
    popupIsVisible: state.orderSummary.popupIsVisible,
    popupItem: state.orderSummary.item,
    selectedData: state.orderSummary.selectedData,
    showAlert: state.orderSummary.showAlert,
    showPopup: state.orderSummary.showPopup,
    page: state.orderSummary.page,
    rowsPerPage: state.orderSummary.rowsPerPage,
    orderBy: state.orderSummary.orderBy,
    order: state.orderSummary.order,
    totalRowsCount: state.orderSummary.totalRowsCount,
    filterNFList: state.orderSummary.filterNFList,
    filters: selectPageFilters(state.orderSummary.pageName)(state),
    pageName: state.orderSummary.pageName,
    vendorOrderRequestPending: state.orderSummary.vendorOrderRequestPending,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    closeAlert: () => dispatch(closeAlert()),
    closePopup: () => dispatch(closePopup()),
    downloadSamples: () => dispatch(downloadSamples()),
    getVendorOrders: (params, doesFiltersUpdated) =>
      dispatch(getVendorOrders(params, doesFiltersUpdated)),
    getVendorOrdersNew: (params, doesFiltersUpdated) =>
      dispatch(getVendorOrdersNew(params, doesFiltersUpdated)),
    locationChange: (selectedData) => dispatch(locationChange(selectedData)),
    onCheckBoxChange: (selectedData) => dispatch(setCheckBox(selectedData)),
    onCanvasTableCheckBoxChange: (selectedIds) =>
      dispatch(setCheckBoxForCanvasTable(selectedIds)),
    onCheckBoxHeaderChange: (selectedData) =>
      dispatch(setCheckBoxHeaderChange(selectedData)),
    showAlert: (message) => dispatch(showAlert(message)),
    showNotification: (isShown, message) =>
      dispatch(showNotification(isShown, message)),
    showPopup: (item) => dispatch(showPopup(item)),
    setShipmentData: (items) => dispatch(setShipmentData(items)),
    setHeaderTitleArray: (headerTitleArray) =>
      dispatch(setHeaderTitleArray(headerTitleArray)),
    setPage: (page) => dispatch(setPage(page)),
    setRowsPerPage: (rowsPerPage) => dispatch(setRowsPerPage(rowsPerPage)),
    handleChipClick: (chip) => {
      copy(chip.target.innerText)
      dispatch(showNotification(true, 'Value Copied to Clipboard', 'info'))
    },
    setFilters: (filters, pageName) => dispatch(setFilters(filters, pageName)),
    setSortedData: (sortedData) => dispatch(setSortedData(sortedData)),
  }
}

OrderSummaryPageCanvas.propTypes = {
  checkBoxEnabled: propTypes.bool,
  columnData: propTypes.array,
  clickableColumn: propTypes.array,
  data: propTypes.array,
  numSelected: propTypes.number,
  onCheckBoxChange: propTypes.func,
  onCheckBoxHeaderChange: propTypes.func,
  onClick: propTypes.func,
  page: propTypes.number,
  rowsPerPage: propTypes.number,
  orderBy: propTypes.string,
  order: propTypes.string,
  orderNumber: propTypes.number,
  vendorId: propTypes.number,
  filterNFList: propTypes.object,
  filters: propTypes.object,
}

export default withHOCs({
  auth: true,
  nav: true,
  connectParams: {
    mapStateToProps,
    mapDispatchToProps,
  },
})(OrderSummaryPageCanvas)
